export async function openAuth(
  redirect_uri: string,
  nonce: string,
  timeout: number = 0,
  keyName: string = 'id_token'
): Promise<{
  data: Record<string, any>;
  error: Record<string, any>;
}> {
  let uri = redirect_uri;
  if (redirect_uri.lastIndexOf('/') === redirect_uri.length - 1) {
    uri = redirect_uri.slice(0, redirect_uri.length - 1);
  }

  return new Promise(async (resolve) => {
    window.AppleID.auth.init({
      response_type: 'code id_token',
      clientId: 'com.phemex.weblogin',
      scope: 'email name',
      redirectURI: uri,
      state: 'initial',
      nonce: nonce,
      usePopup: true,
    });
    try {
      const data = await window.AppleID.auth.signIn().catch((err) => {
        throw err;
      });
      console.log('===apple-data=', data);
      resolve({data: data.authorization, error: null});
    } catch (error) {
      console.error('===apple-data=', error);
      resolve({data: null, error});
    }
  });
}
